import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const Page = ({ className, children, classes }) => {
  const { themeClasses } = useThemePresetClasses("Page", classes, className);
  return /* @__PURE__ */ jsx("div", { className: cn("flex min-h-dvh w-full max-w-md flex-col", themeClasses == null ? void 0 : themeClasses.root), children });
};
const Page$1 = Page;
export {
  Page$1 as default
};
